
import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }: any) => {

    const cookies = new Cookies(null, { path: '/' });
    const user = cookies.get('USER') || null

    const navigate = useNavigate();

    const login = async (res: any) => {
        if(res?.status == 1 && res.data?.token){
            const { access_token, token_type } = res.data.token;
            cookies.set('ACCESS_TOKEN', access_token)
            cookies.set('TOKEN_TYPE', token_type)
            cookies.set('USER', res.data.user)
            navigate("/dashboard");
        }
    };

    const logout = () => {
        cookies.remove('ACCESS_TOKEN');
        cookies.remove('TOKEN_TYPE');
        cookies.remove('USER');
        navigate("/", { replace: true });
    };

    const value: any = useMemo(
        () => ({
            user,
            login,
            logout,
        }),
        [user]
    );
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};